import { ChangeEvent } from 'react';
import { clsx } from 'clsx';

import { TSwitchProps } from '@/ui-kit/switch/Switch.types';

export function Switch<T>({
  label,
  hint,
  content,
  isEnabled,
  isDisabled = false,
  handleChange,
  data,
  className = '',
  testId = '',
}: TSwitchProps<T>) {
  return (
    <div className="flex items-start gap-3">
      <label
        aria-hidden="true"
        className={clsx(
          'relative m-2 inline-block w-[36px] h-[20px] rounded-500 transition-all duration-200 border-[1px] group cursor-pointer',
          isDisabled
            ? 'bg-disabled border-disabled !cursor-auto'
            : isEnabled
              ? 'bg-button-primary-default-default border-interactive hover:bg-button-primary-default-hover hover:border-button-primary-default-hover'
              : 'bg-interactive border-secondary hover:bg-button-primary-default-default hover:bg-opacity-20 hover:border-interactive',
          className,
        )}
      >
        <input
          type="checkbox"
          className="sr-only peer"
          disabled={isDisabled}
          checked={isEnabled}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            handleChange?.(e.currentTarget.checked, data);
          }}
          data-testid={testId}
        />
        <span
          className={clsx(
            'absolute top-[-1px] left-[-1px] w-[20px] h-[20px] bg-primary border-[1px] rounded-full transition-all duration-200',
            isDisabled
              ? 'bg-disabled border-disabled'
              : isEnabled
                ? 'border-button-primary-default-default group-hover:border-button-primary-default-hover'
                : 'border-secondary group-hover:border-interactive',
            isEnabled ? 'translate-x-[16px]' : 'translate-x-0',
          )}
        />
      </label>

      {label && (
        <div className="flex flex-col w-fit py-2 gap-3">
          <div className="flex flex-col">
            <h4 className={clsx('typo-body-regular-paragraph', isDisabled ? 'text-disabled' : 'text-primary')}>
              {label}
            </h4>
            {hint && (
              <span className={clsx('typo-body-regular-caption', isDisabled ? 'text-disabled' : 'text-tertiary')}>
                {hint}
              </span>
            )}
          </div>
          {content}
        </div>
      )}
    </div>
  );
}
